
const state = {
  toqapage:''
}

const mutations = {
  SET_QAPAGE: (state, name) => {
    state.toqapage = name
  },
}

const actions = {

}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/album.js